<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-between border-b pb-3">
      <h2 class="text-xl font-semibold tracking-tight">Tech Stack</h2>
      <a href="/techstack" class="text-sm font-medium hover:underline text-muted-foreground">View All &rarr;</a>
    </div>

    <div class="flex flex-wrap gap-2 mt-4">
      <Badge
        v-for="skill in skills"
        :key="skill"
        variant="outline"
        class="tech-tag border-foreground/30 bg-transparent font-mono font-normal text-sm py-1 px-3 text-foreground hover:bg-muted/30"
      >
        {{ skill }}
      </Badge>
    </div>
  </div>
</template>

<script>
import Badge from './ui/Badge.vue';

export default {
  name: "SkillsSection",
  components: {
    Badge
  },
  data() {
    return {
      skills: [
        "HTML5", "CSS3", "JavaScript", "Vue.js", "Tailwind CSS", 
        "Node.js", "Bootstrap", "PHP", "npm", "PostgreSQL", 
        "cPanel", "DigitalOcean", "Taiga.io", "Vercel", "Git", 
        "Figma", "GitHub", "JIRA", "Postman"
      ]
    };
  }
};
</script>

<style scoped>
.tech-tag {
  display: inline-block;
  padding: 0.3rem 1.25rem;
  cursor: default;
}

@media (max-width: 768px) {
  .tech-tag {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
  }
}
</style>
